module.exports = __webpack_public_path__ + "static/esports-logo-165c0aab48fe5f0373ccbd5f4d72ef49.png";